export enum DriverAwardType {
    AwesomeDriver = 1,
    ComfortableDriving = 2,
    CleanCar = 3,
    GreatConversation = 4,
    ExpertNavigation = 5,
    ExcellentService = 6,
    NeatAndTidy = 7,
    AwesomeMusic = 8,
    EntertainingDriver = 9,
    LateNightHero = 10,
	UnsafeDriving = 11,
	RudeOrUnprofessional = 12,
	ChargedUnfairly = 13,
	PoorNavigation = 14,
	VehicleCondition = 15,
	Other = 16,
    Rude = 18,
    DirtyVehicle = 19,
    NotInUniform = 20,
    Overloading = 21,
    UnderInfluence = 22,
    TripCutting = 23,
    CoolCar = 24,
}
